<a *ngIf="linkUrl" [routerLink]="[linkUrl]">{{params.value}}</a>
<span *ngIf="!linkUrl">{{params.value}}</span>
